import { Button } from "@/components/ui/button";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import { AlertCircle } from "lucide-react";

export interface ConfirmationModalProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
  options?: {
    title: string;
    description?: string;
    confirmText?: string;
    cancelText?: string;
  };
}

export function ConfirmationModal({
  isOpen,
  onConfirm,
  onClose,
  options = {
    title: "Confirmation",
    description: "Are you sure you want to confirm this action?",
    confirmText: "Confirm",
    cancelText: "Cancel",
  },
}: ConfirmationModalProps) {
  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogContent>
        <DialogHeader>
          <div className="flex items-center gap-3">
            <AlertCircle className="h-6 w-6 text-primary" />
            <DialogTitle>{options.title}</DialogTitle>
          </div>
          <DialogDescription>{options.description}</DialogDescription>
        </DialogHeader>
        <DialogFooter className="gap-2 sm:gap-0">
          <Button variant="outline" onClick={onClose}>
            {options.cancelText}
          </Button>
          <Button onClick={onConfirm}>{options.confirmText}</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
